module.exports = __webpack_public_path__ + "img/loading-mini-white.604cd5b4.gif";